<template>
    <div class="form-group">
        <div class="on-off-toggle">
            <button
                :id="monthlyId"
                :checked="IsMonthly"
                name="contribution"
                type="button"
                value="monthly"
                @click="updateStatus($event.target)">
            </button>
            <button
                :id="yearlyId"
                :checked="!IsMonthly"
                name="contribution"
                type="button"
                value="yearly"
                @click="updateStatus($event.target)">
            </button>
            <div class="toggle-text">
                <label
                    :for="monthlyId"
                    :class="{ 'selected': IsMonthly, '' : !IsMonthly}">
                    Monthly
                </label>
                <label
                    :for="yearlyId"
                    :class="{ '': IsMonthly, 'selected' : !IsMonthly}">
                    Yearly
                </label>
                <div
                    class="toggle-bg"
                    :class="{ 'monthly': IsMonthly, 'yearly' : !IsMonthly}">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            monthlyId: {
                type: String,
                default: '',
            },
            yearlyId: {
                type: String,
                default: '',
            },
            isMonthly: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                IsMonthly: this.isMonthly,
            };
        },
        methods: {
            updateStatus(target = '') {
                if (target === '') {
                    this.IsMonthly = true;
                    this.$emit('updateStatus', 'monthly');
                } else {
                    this.IsMonthly = !this.IsMonthly;
                    this.$emit('updateStatus', target.value);
                }
            },
        },
    };
</script>

<style lang="scss">
@import "../../assets/styles/v2/variables";

#lt-yantr-v2 {
    /* On-Off Toggle Style */
    .on-off-toggle {
        background: $steam;
        height: 50px;
        position: relative;
        border-radius: $br-3;
        display: flex;

        button {
            width: 1px;
            height: 1px;
            position: absolute;
            opacity: 0;
        }

        .toggle-text {
            width: 100%;
            position: relative;
            @include display-fw-ai-jc(null, center, null);

            label {
                text-align: center;
                width: 50%;
                height: 100%;
                margin: 0;
                position: relative;
                z-index: 1;
                transition: $t-5ms;
                cursor: pointer;
                @include display-fw-ai-jc(null, center, center);

                &.selected {
                    font-weight: bold;
                }
           }

            .toggle-bg {

                &.monthly {
                    left: 3px;
                }

                &.yearly {
                    left: calc(50% - 3px);

                    /* IE 11 browser specific Css */
                    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
                        left: 49%;
                    }
                }
            }
        }

        .toggle-bg {
            background: $white;
            width: 50%;
            height: 44px;
            position: absolute;
            top: 3px;
            left: 3px;
            border-radius: $br-3;
            box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
            transition: $t-5ms;
        }
    }
}
</style>
